import { StyleSheet } from 'react-native';
export var getServiceCardWidgetStyles = () => {
  return StyleSheet.create({
    container: {
      width: 158,
      minHeight: 208
    },
    upperSectionContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 6
    },
    btnContainer: {
      marginTop: 'auto',
      alignItems: 'flex-end'
    }
  });
};